import { COMPANY_INFO } from "constants/company_info"
import Link from "next/link"
import React from "react"
import { FaThreads, FaXTwitter, FaTiktok } from "react-icons/fa6"
import { FiInstagram } from "react-icons/fi"

interface IProps {
    size?: number
    gap?: number
    width?: number | string
}

const AppSocialMedia = ({ size = 22, gap = 8, width }: IProps) => {
    return (
        <div
            style={{ width: width ?? width, gap: gap }}
            className="flex items-center justify-end">
            <Link
                target="_blank"
                href={COMPANY_INFO.social_media.threads}>
                <FaThreads
                    size={size}
                    className="cursor-pointer opacity-70 hover:opacity-100"
                />
            </Link>
            <Link
                target="_blank"
                href={COMPANY_INFO.social_media.instagram}>
                <FiInstagram
                    size={size}
                    className="cursor-pointer opacity-70 hover:opacity-100"
                />
            </Link>
            <Link
                target="_blank"
                href={COMPANY_INFO.social_media.twitter}>
                <FaXTwitter
                    size={size}
                    className="cursor-pointer opacity-70 hover:opacity-100"
                />
            </Link>
            <Link
                target="_blank"
                href={COMPANY_INFO.social_media.tiktok}>
                <FaTiktok
                    size={size}
                    className="cursor-pointer opacity-70 hover:opacity-100"
                />
            </Link>
        </div>
    )
}

export default AppSocialMedia
